import React, {useState} from "react";
import {Link} from "react-router-dom";
import PrivacyModal from "./PrivacyModel";


const Footer = () => {
    const [isPrivacyModalOpen, setIsPrivacyModalOpen] = useState(false);

    const handleContactClick = () => {
        window.open('mailto:harshmarkandey2022@vitbhopal.ac.in', '_blank');
    };

    return (
        <>
            <footer className="bg-white/20 backdrop-blur-lg py-8">
                <div className="container mx-auto px-4 text-center">
                    <div className="flex flex-col md:flex-row justify-center space-y-4 md:space-y-0 md:space-x-6 mb-4">
                        <Link to="/about" className="text-white hover:text-blue-200">About</Link>
                        <button
                            onClick={handleContactClick}
                            className="text-white hover:text-blue-200"
                        >
                            Contact
                        </button>
                        <button
                            onClick={() => setIsPrivacyModalOpen(true)}
                            className="text-white hover:text-blue-200"
                        >
                            Privacy
                        </button>
                    </div>
                    <p className="text-white/80">© 2024 HealthoTechClub. All Rights Reserved.</p>
                </div>
            </footer>

            {isPrivacyModalOpen && (
                <PrivacyModal onClose={() => setIsPrivacyModalOpen(false)} />
            )}
        </>
    );
};

export default Footer;